export function loadYqChart(
  myChart,
  dycyN,
  decyN,
  dscyN,
  dycy,
  decy,
  dscy,
  unit = "万元"
) {
  var getname = [dycyN, decyN, dscyN];

  var getvalue = [dycy, decy, dscy];
  var data = [];

  for (var i = 0; i < getname.length; i++) {
    data.push({ name: getname[i], value: getvalue[i] });
  }

  var colorList = ["#1890FF", "#12DDA1", "#FFB026"];
  var colorList1 = ["#1183ED", "#00CF92", "#EF9D0F"];

  myChart.setOption({
    title: [
      {
        text: "产业园占比",
        top: "center",
        left: "center",
        textStyle: {
          color: "#fff",
          fontSize: 12
        }
      }
    ],
    tooltip: {
      trigger: "item",
      formatter: "{b}：<br />{c}" + unit
    },
    series: [
      {
        type: "pie",
        radius: ["55%", "75%"],
        center: ["50%", "50%"],
        itemStyle: {
          normal: {
            color: function(params) {
              return colorList[params.dataIndex];
            }
          }
        },

        label: {
          normal: {
            show: false
          }
        },

        labelLine: {
          normal: {
            show: false
          }
        },

        data: data
      },
      {
        type: "pie",

        radius: ["50%", "60%"],

        center: ["50%", "50%"],

        itemStyle: {
          normal: {
            color: function(params) {
              return colorList1[params.dataIndex];
            }
          }
        },
        label: {
          show: true,

          normal: {
            formatter: params => {
              return (
                "{percent|" + params.percent + "%} {name|" + params.name + "} "
              );
            },
            distanceToLabelLine: 0,
            padding: [-10, 10, -150, 50],
            rich: {
              name: {
                color: "#656565",
                fontSize: 14,
                padding: [6, 50, 6, 0],
                align: "left"
              },
              percent: {
                color: "#656565",
                align: "center",
                fontWeight: "bold",
                fontSize: 14,
                padding: [5, 10, 5, 0]
              }
              // hr: {
              //     borderColor: '#C8C8C8',
              //     width: '100%',
              //     borderWidth: 0.5,
              //     height: 0,
              // },
            }
          }
        },

        labelLine: {
          normal: {
            show: false
          }
        },

        data: data
      }
    ]
  });
}
